/**
 * Component: M8 FAQ
 * 
 */
'use strict';

export class Faq
{
  constructor()
  {
    this.selectors = {
      component:    $('.c-v4-m8-faq'),
      items_hidden: $('.c-v4-m8-faq--main-item.d-none'),
      more:         $('.c-v4-m8-faq--main-more a.text-link')
    };
  }

  init()
  {
    let _self = this;

    this.selectors.more.on('click', function ( e )
    {
      e.preventDefault();

      let c = $(this).children();

      // Show more
      if ( $(this).hasClass('arrow_down') )
      {
        _self.selectors.items_hidden.addClass('d-block');
        
        $(this).removeClass('arrow_down')
          .addClass('arrow_up')
          .text('see less')
          .append(c);
      }

      // Show less
      else
      {
        _self.selectors.items_hidden.removeClass('d-block');

        $(this).removeClass('arrow_up')
          .addClass('arrow_down')
          .text('see more')
          .append(c);
      }
    });
  }
}